import { CopyButton } from '@skupreme/shared/ui';
import { StopRowClick } from '../common/StopRowClick';

/** EN-4464: the column and field label of the short Skupreme order id. */
export const SHORT_ID_LABEL = 'Skupreme #';

export type ShortIdCellProps = {
  /** V2 only; null for orders that came in before the id existed. */
  shortId?: string | null;
};

/** The order's short Skupreme id with a copy button, or a dash when it has none. */
export function ShortIdCell({ shortId }: ShortIdCellProps) {
  if (!shortId) {
    return <span className="sk:text-fg-tertiary">—</span>;
  }

  return (
    <span className="sk:inline-flex sk:max-w-full sk:items-center sk:gap-1">
      <span className="sk:min-w-0 sk:truncate sk:font-mono sk:font-medium">
        {shortId}
      </span>
      <StopRowClick>
        <CopyButton value={shortId} label={`Copy ${SHORT_ID_LABEL}`} />
      </StopRowClick>
    </span>
  );
}
